/*
 * Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import { inject } from '@angular/core';
import { CanMatchFn, Router } from '@angular/router';
import { LocalStorageService } from 'ngx-webstorage';

const parseJwt = (token: string) => {
  const base64Url = token.split('.')[1];
  const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
  return JSON.parse(window.atob(base64));
};

//const starting in uppercase in order to have the same API as with classes
export const StoreAuthenticationTokenInLocalStorageIfPresentGuard: CanMatchFn = () => {
  const localStorage = inject(LocalStorageService);
  const router = inject(Router);
  const queryParams = router.getCurrentNavigation()?.initialUrl.queryParams;

  if (queryParams && queryParams['token']) {
    const decodedJwt = parseJwt(queryParams['token']);
    localStorage.clear();
    localStorage.store('authenticationToken', queryParams['token']);
    localStorage.store('owner', decodedJwt.owner);

    const currentUrlTree = router.getCurrentNavigation()?.initialUrl;
    delete currentUrlTree?.queryParams['token'];
    return currentUrlTree;
  }

  return true;
};
